import { useFlags } from "launchdarkly-react-client-sdk";

const useCanAccessRetailAttribution = () => {
  const { whitelabelRetailAttribution } = useFlags();
  return whitelabelRetailAttribution;
};

export default useCanAccessRetailAttribution;
